import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cc-web-v4/components/project/ProjectClientBottom.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cc-web-v4/components/TranslationsProvider.js");
;
import(/* webpackMode: "eager" */ "/var/www/cc-web-v4/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/cc-web-v4/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www/cc-web-v4/styles/news.scss");
